<template>
  <div class="settings-form">
    <div class="form-group">
      <label class="form-label">Content</label>
      <textarea 
        v-model="localSettings.content"
        class="form-textarea"
        rows="4"
        @input="emitUpdate"
      ></textarea>
    </div>

    <div class="form-group">
      <label class="form-label">Tag</label>
      <select v-model="localSettings.tag" class="form-select" @change="emitUpdate">
        <option value="p">Paragraph</option>
        <option value="h1">Heading 1</option>
        <option value="h2">Heading 2</option>
        <option value="h3">Heading 3</option>
        <option value="h4">Heading 4</option>
        <option value="h5">Heading 5</option>
        <option value="h6">Heading 6</option>
      </select>
    </div>

    <div class="form-group">
      <label class="form-label">Alignment</label>
      <select v-model="localSettings.align" class="form-select" @change="emitUpdate">
        <option value="left">Left</option>
        <option value="center">Center</option>
        <option value="right">Right</option>
        <option value="justify">Justify</option>
      </select>
    </div>

    <div class="form-group">
      <label class="form-label">CSS Class</label>
      <input 
        v-model="localSettings.class"
        type="text"
        class="form-input"
        placeholder="custom-class"
        @input="emitUpdate"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  settings: {
    type: Object,
    required: true
  }
});

const emit = defineEmits(['update']);

const localSettings = ref({ ...props.settings });

watch(() => props.settings, (newSettings) => {
  localSettings.value = { ...newSettings };
}, { deep: true });

function emitUpdate() {
  emit('update', localSettings.value);
}
</script>

